<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.first_name }}</td>
                            <td>{{ item.email }}</td>
                            <td v-bind:style="{ 'color': item.is_active == 1 ? '#0059b3' : '#e63900'}">{{ item.is_active == 1 ? 'Kích hoạt' : 'Đã khóa' }}</td>
                            <td class="text-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon medium class="mr-2" color="red" @click="resetPassword(item.id)" v-on="on">autorenew</v-icon>
                                    </template>
                                    <span>Reset mật khẩu về mặc định</span>
                                </v-tooltip>                                
                                <v-icon medium class="mr-2" @click="openItem(item.id)">edit</v-icon>
                                <v-icon medium :disabled="item.id == 1" @click="deleteItem(item.id)">delete</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogItem" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="title">Chi tiết tài khoản</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-text-field label="Tài khoản" v-model="currentItem.phone" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 v-if="!currentItem.id">
                    <v-text-field label="Mật khẩu" v-model="currentItem.password" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12>
                    <v-text-field label="Họ tên" v-model="currentItem.first_name" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12>
                    <v-text-field label="Phone" v-model="currentItem.email" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6>
                    <v-select label="Quyền hạn" class="input-group--focused" v-model="currentItem.role" :items="role_list" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg6 pt-6 pl-6>
                    <v-switch label="Kích hoạt" v-model="currentItem.is_active" class="input-group--focused"></v-switch>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
          <v-btn @click="editItem">Cập nhật</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "user_list",
            dialogItem: false,
            headers: [{
                    text: "ID",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tài khoản",
                    value: "phone",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Họ tên",
                    value: "first_name",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Phone",
                    value: "email",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái",
                    value: "is_active",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.users.all.data,
            total_rows: state => state.users.all.total,
            loading: state => state.users.loading,
            currentItem: (state) => state.users.selected
        }),
        role_list() {
            return _.filter(configs.ROLES, (p) => {return p.value != configs.ROLE_TYPE.Customer});
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            param.filter.push({column: 'role', value: [configs.ROLE_TYPE.Admin, configs.ROLE_TYPE.Staff], condition: "in"});
            this.$store.dispatch("users/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openItem: function (id) {
            if(!id) {
                this.$store.commit("users/setDetail", {'id': id});
            }
            else {
                this.$store.dispatch("users/getDetail", id);
            }
            this.dialogItem = true;
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        editItem() {
            let payload = {
                    'phone': this.currentItem.phone,
                    'first_name': this.currentItem.first_name,
                    'email': this.currentItem.email,
                    'role': this.currentItem.role,
                    'is_active': this.currentItem.is_active
                }
            if(!this.currentItem.id) {
                payload.password = this.currentItem.password
            }
            this.$store.dispatch("users/setDetail", {
                'data': payload,
                'id': this.currentItem.id
            });
            this.dialogItem = false;
        },
        resetPassword: function(id) {
            this.$store.dispatch("users/setDetail", {
                'data': {password: '12345678'},
                'id': id,
                'notify': 'Đã reset mật khẩu về mặc định (12345678)'
            });
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("users/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
